exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-add__amount-field>div:first-child {\n  width: 24rem !important;\n}\n\n", ""]);

// exports
